import type {
  CreditAccountTransaction} from "@/__generated__/graphql";
import {
  CreditAccountByIdDocument
} from "@/__generated__/graphql";
import { useQuery } from "@apollo/client";

export const useCreditAccountByIdQuery = (id: string) => {
  const result = useQuery(CreditAccountByIdDocument, {
    skip: !id,
    variables: {
      id,
    },
  });

  const creditAccount = result.data?.creditAccountById;

  const transactions: CreditAccountTransaction[] = (
    creditAccount?.transactions ?? []
  )
    .filter((t) => t.authorizedAt != null)
    .map((t) => ({
      ...t,
      creditAccount: {
        id: creditAccount?.id ?? id,
      },
    })) as CreditAccountTransaction[];

  return {
    ...result,
    creditAccount,
    transactions,
  };
};
